module.exports = __webpack_public_path__ + "img/medsafe-logo.dc4250d2.png";